import { components as RSComponents } from 'react-select';
import { Tooltip } from '@chakra-ui/react';

// Chip / single-value labels truncate with CSS ellipsis at ~28 chars
// (`customFilterStyles.multiValueLabel` / `.singleValue`). Wrap the label
// in a Chakra Tooltip here so hover surfaces the full text.
// `shouldWrapChildren` lets Tooltip attach hover handlers without requiring
// react-select's value components to forward refs (they don't).
export const CHIP_TOOLTIP_THRESHOLD = 28;

export const TooltipMultiValueLabel = (props: any) => {
  const raw = typeof props.children === 'string' ? props.children : '';
  const label = <RSComponents.MultiValueLabel {...props} />;
  if (!raw || raw.length <= CHIP_TOOLTIP_THRESHOLD) return label;
  return (
    <Tooltip
      label={raw}
      placement="top"
      hasArrow
      openDelay={150}
      shouldWrapChildren
    >
      {label}
    </Tooltip>
  );
};

export const TooltipSingleValue = (props: any) => {
  const raw = typeof props.children === 'string' ? props.children : '';
  const value = <RSComponents.SingleValue {...props} />;
  if (!raw || raw.length <= CHIP_TOOLTIP_THRESHOLD) return value;
  return (
    <Tooltip
      label={raw}
      placement="top"
      hasArrow
      openDelay={150}
      shouldWrapChildren
    >
      {value}
    </Tooltip>
  );
};
